import React from 'react'

export default function FaceFeature({ scaleX, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} style={{ opacity: 0.2 }}>
      <path
        d="M5.25697 0.104492C3.78697 1.98449 2.66696 4.02451 2.18696 6.24451C1.93696 7.34451 1.81699 8.48451 1.89699 9.62451C1.91699 10.7745 2.17699 11.9045 2.39699 13.0945C1.78699 12.0645 1.29696 10.9245 1.11696 9.70447C0.876957 8.49447 0.946983 7.22441 1.20698 6.02441C1.48698 4.81441 1.97695 3.65441 2.67695 2.64441C3.36695 1.64441 4.22697 0.744492 5.25697 0.104492Z"
        fill={outline}
      />
      <path
        d="M26.3169 0.104492C27.3369 0.744492 28.1969 1.64441 28.8969 2.64441C29.5969 3.65441 30.0869 4.81441 30.3669 6.02441C30.6269 7.23441 30.7069 8.49447 30.4569 9.70447C30.2769 10.9245 29.7869 12.0645 29.1769 13.0945C29.3969 11.9045 29.6569 10.7745 29.6769 9.62451C29.7569 8.48451 29.6369 7.34451 29.3869 6.24451C28.9069 4.03451 27.7869 1.98449 26.3169 0.104492Z"
        fill={outline}
      />
    </g>
  )
}
